import service from '@api/config'

// 获取邀工资讯列表
export const newsList = (data) => {
  return service.request({
    url: `/content/news`,
    method: 'post',
    data: data
  })
}

// 获取邀工资讯详情
export const newsInfo = (data) => {
  return service.request({
    url: `/content/news/info`,
    method: 'post',
    data: data
  })
}
